import { Link } from 'react-router-dom'
import { Page, Stepper } from '../components/Layout'
import { ErrorBox } from '../components/ui'
import { Login } from '../components/Login'
import { TimelineCaso } from '../components/TimelineCaso'
import { useAuth } from '../hooks/useAuth'
import { useRealtimeCaso } from '../hooks/useRealtimeCaso'
import { supabase } from '../lib/supabase'
import { brl, dataBR, statusLabel } from '../lib/format'
import { derivarTimeline } from '../lib/timeline'

export default function DashboardCliente() {
  const { user, loading } = useAuth()
  const { caso, eventos, pagamentos, loading: loadingCaso, erro } = useRealtimeCaso()

  if (loading) return <Page><p className="text-pfa-slate">Carregando…</p></Page>
  if (!user) return <Page><Login /></Page>

  return (
    <Page>
      <Stepper step={4} />
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold text-pfa-navy">Meu caso</h1>
        <button className="text-sm text-pfa-slate hover:text-pfa-navy" onClick={() => supabase.auth.signOut()}>
          Sair
        </button>
      </div>

      <div className="mt-4">
        <ErrorBox message={erro} />
      </div>
      {loadingCaso ? (
        <p className="mt-4 text-pfa-slate">Carregando seu caso…</p>
      ) : erro ? null : !caso ? (
        <div className="card mt-4">
          <p className="text-pfa-slate">Ainda não encontramos um caso vinculado a esta conta.</p>
        </div>
      ) : (
        <div className="mt-4 grid gap-6 md:grid-cols-3">
          {pagamentos.length > 0 && (
            <div className="card border-l-4 border-pfa-coral md:col-span-3">
              <h2 className="font-semibold text-pfa-navy">Pagamento da entrada</h2>
              <div className="mt-3 space-y-3">
                {pagamentos.map((p) => {
                  const pago = p.status === 'recebido'
                  const pagavel = (p.status === 'pendente' || p.status === 'vencido') && !!p.link_pagamento
                  return (
                    <div key={p.id} className="flex flex-wrap items-center justify-between gap-3">
                      <div>
                        <p className="text-sm text-pfa-slate">
                          {p.tipo === 'entrada' ? 'Entrada' : p.tipo} ·{' '}
                          <strong className="text-pfa-navy">{brl(p.valor)}</strong>
                          {p.vencimento && !pago ? ` · vence ${dataBR(p.vencimento)}` : ''}
                        </p>
                        <p className="text-xs text-pfa-slate/70">{statusLabel(p.status)}</p>
                      </div>
                      {pago ? (
                        <span className="rounded-full bg-green-100 px-3 py-1 text-sm font-medium text-green-700">
                          ✓ Pago
                        </span>
                      ) : pagavel ? (
                        <a href={p.link_pagamento!} target="_blank" rel="noopener noreferrer" className="btn-accent">
                          Pagar agora
                        </a>
                      ) : (
                        <span className="text-xs text-pfa-slate/70">Gerando o link de pagamento…</span>
                      )}
                    </div>
                  )
                })}
              </div>
              <p className="mt-3 text-xs text-pfa-slate/70">
                Pagamento por boleto ou cartão. Esta cobrança só existe porque a liminar que suspende suas parcelas foi
                deferida.
              </p>
            </div>
          )}

          <div className="card md:col-span-1">
            <p className="text-sm text-pfa-slate">Status atual</p>
            <p className="mt-1 text-xl font-semibold text-pfa-navy">{statusLabel(caso.status)}</p>
            {caso.empreendimento && <p className="mt-3 text-sm text-pfa-slate">{caso.empreendimento}</p>}
            {caso.construtora && <p className="text-sm text-pfa-slate/80">{caso.construtora}</p>}
            <Link to="/documentos" className="btn-ghost mt-4 w-full">Enviar documentos</Link>
          </div>

          <div className="card md:col-span-2">
            <h2 className="font-semibold text-pfa-navy">Acompanhe seu caso</h2>
            <div className="mt-4">
              <TimelineCaso fases={derivarTimeline(caso, eventos, pagamentos)} />
            </div>
          </div>
        </div>
      )}
    </Page>
  )
}
